import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
//64b114c40df4500fda2f73c3
import { useMemo } from "react";
import { useLocation } from "react-router-dom";
const ShippingDoc = () => {
    const { search } = useLocation();
    const params = useMemo(() => new URLSearchParams(search), [search]);
    const id = params.get("id");
    return (_jsxs("div", Object.assign({ style: {
            position: "absolute",
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        } }, { children: [id && (_jsx("iframe", { src: `https://shipdocgenerator.vercel.app?id=${id}`, width: "100%", height: "100%" })), !id && _jsx("p", { children: "Please provide an order id" })] })));
};
export default ShippingDoc;
